<template>
  <div class="field" :class="horizontal ? 'is-horizontal' : ''">
    <slot class="field-label is-small" name="label"></slot
    ><span v-if="horizontal">&nbsp;</span>
    <div class="field-body">
      <div class="field">
        <p
          class="control is-expanded"
          :class="(hasIcon && 'has-icons-left') || ''"
        >
          <slot></slot>
          <span class="icon is-small is-left" v-show="hasIcon">
            <slot name="icon"></slot>
          </span>
        </p>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "HorizField",
  props: {
    horizontal: {
      type: Boolean,
      default: true
    }
  },
  computed: {
    hasIcon() {
      return !!this.$slots.icon;
    }
  }
};
</script>

<style lang="scss"></style>
